/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { BEM } from "@adapptio/lib-components";
import React, { FC } from "react";

/**
 * Dialog sizes
 */
export enum DIALOG_SIZE {
	SMALL = "small",
	MEDIUM = "medium",
	LARGE = "large",
	FULL = "full",
	AUTO = "auto"
}

/**
 * Component props
 */
export interface IDialogPanelProps {
	size?: DIALOG_SIZE;
	className?: string;
	autoHeight?: boolean;
	preventBaseStyles?: boolean;
}

/**
 * Dialog Panel
 * Displays base dialog box.
 * @param props Component props
 */
export const DialogPanel: FC<IDialogPanelProps> = ({
	size,
	className,
	children,
	autoHeight,
	preventBaseStyles
}) => {
	const baseClass = BEM("edt-dialog", "panel");
	baseClass.mod("size-" + (size || DIALOG_SIZE.AUTO));

	if (!preventBaseStyles) {
		baseClass.add("edt-base");
	}

	if (className) {
		baseClass.add(className);
	}

	if (autoHeight) {
		baseClass.mod("auto-height-content");
	}

	return <div className={baseClass.toClassName()}>{children}</div>;
};
